(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.pl = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = {
    el: {
      autocomplete: {
        noDataMessage: 'Nie znaleziono żadnych danych'
      },
      combobox: {
        placeholder: 'Wybierz',
        searchPlaceholder: 'Szukaj'
      },
      datepicker: {
        apply: 'Zastosuj',
        clearSelection: 'Wyczyść',
        pickADays: 'Wybierz dni',
        prevYear: 'Poprzedni rok',
        nextYear: 'Następny rok',
        prevMonth: 'Poprzedni miesiąc',
        nextMonth: 'Następny miesiąc',
        year: '',
        month1: 'Styczeń',
        month2: 'Luty',
        month3: 'Marzec',
        month4: 'Kwiecień',
        month5: 'Maj',
        month6: 'Czerwiec',
        month7: 'Lipiec',
        month8: 'Sierpień',
        month9: 'Wrzesień',
        month10: 'Październik',
        month11: 'Listopad',
        month12: 'Grudzień',
        weeks: {
          sun: 'Nie',
          mon: 'Pon',
          tue: 'Wto',
          wed: 'Śro',
          thu: 'Czw',
          fri: 'Pią',
          sat: 'Sob'
        },
        months: {
          jan: 'Sty',
          feb: 'Lut',
          mar: 'Mar',
          apr: 'Kwi',
          may: 'Maj',
          jun: 'Cze',
          jul: 'Lip',
          aug: 'Sie',
          sep: 'Wrz',
          oct: 'Paź',
          nov: 'Lis',
          dec: 'Gru'
        },
        pickADay: 'Wybierz dzień'
      },
      timepicker: {
        meridiemAM: 'AM',
        meridiemPM: 'PM'
      },
      dropdown: {
        noDataMessage: 'Nie znaleziono żadnych danych'
      },
      filepicker: {
        browse: 'Przeglądaj',
        select: 'Wybierz plik'
      },
      filter: {
        apply: 'Zastosuj',
        cancel: 'Anuluj',
        filterButton: 'Filtruj',
        reset: 'Resetuj filtry',
        resetDefault: 'Przywróć domyślne'
      },
      search: {
        noDataMessage: 'Nie znaleziono żadnych danych'
      },
      'multi-search': {
        'separator-and': 'I',
        'search-button': 'Szukaj',
        'search-placeholder': 'Szukaj wg nazwy'
      },
      select: {
        all: 'Wszystkie',
        clearSelection: 'Wyczyść wybór',
        noMatch: 'Nie znaleziono żadnych danych',
        noData: 'Brak danych',
        placeholder: 'Wybierz',
        item: 'elem.',
        selected: 'wybrano',
        found: 'znaleziono'
      },
      upload: {
        browseButton: 'Przeglądaj',
        text: 'Przeciągnij i upuść plik do przesłania lub kliknij „Przeglądaj”',
        tip: 'Możesz przesłać do 10 plików o rozmiarze do 25 MB'
      },
      table: {
        emptyText: 'Brak danych'
      },
      tree: {
        emptyText: 'Brak danych'
      }
    }
  };
  _exports.default = _default;
});